import { defineMessages } from 'react-intl';

export const viewRolePermissionsMessages: {
	roleDisabledLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	roleDisabledLabel: {
		id: 'space-roles.view-role-permissions-modal.role-disabled-label',
		defaultMessage: 'Role disabled',
		description:
			'Label for the disabled role indicator shown in both the sidebar icon and the detail view lozenge of the view permissions modal',
	},
});
